import { setKeyword, setShopProfile } from '@common/lib/common/utils';

export default {
  props: {
    store: Object,
    idx: Number,
  },
  computed: {
    calcScore() {
      return Math.round(this.store.evaluationScore * 10) / 10;
    },
  },
  methods: {
    goShopDetail(shop) {
      this.$emit('goShopDetail', shop.id, this.idx);
    },
    toggle(id) {
      this.$emit('toggle', id);
    },
    colorWord(content) {
      const keyword = this.$route.query.keyword;
      return setKeyword(content, keyword);
    },
    setShopProfileImg(shopName, shopId) {
      console.log(this.shop);
      let path = setShopProfile(shopName, shopId, '150x150');

      return path;
    },
  },
};
